module.exports = __webpack_public_path__ + "img/level6-21.f2273850.png";